import { Tooltip, TooltipProps } from "antd"

const DisabledFieldTooltip = ({
  disabled,
  tooltip,
  children,
  tooltipProps,
}: {
  disabled?: boolean
  tooltip?: string
  children: React.ReactNode
  tooltipProps?: TooltipProps
}) => {
  if (disabled)
    return (
      <Tooltip title={tooltip} {...tooltipProps}>
        <span>{children}</span>
      </Tooltip>
    )

  return children
}

export default DisabledFieldTooltip
